<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "admin",
  components: {},
  methods: {}
};
</script>
<style scoped>
.content {
  padding: 16px;
}
</style>
